import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { ActionButton } from './ActionButton';
function useCountdown() {
  const [seconds, setSeconds] = useState(23 * 3600 + 34 * 60 + 39);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(0, value - 1)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  return [Math.floor(seconds / 3600), Math.floor(seconds % 3600 / 60), seconds % 60].map(value => String(value).padStart(2, '0'));
}
interface PricingProps {
  showAnchor?: boolean;
  description?: string;
}
export function Pricing({
  showAnchor = false,
  description = 'Todo el sistema en PDF + 5 herramientas prácticas de implementación.'
}: PricingProps) {
  const [hours, minutes, seconds] = useCountdown();
  return <section id={showAnchor ? 'pricing' : undefined} className="bg-surface" data-id="element-117" data-mp="3h6lf20mespb5">
      <div className="bg-urgency-surface px-4 py-16 sm:py-20" data-id="element-118" data-mp="3c8jutcd8yjy3">
        <div className="mx-auto max-w-4xl text-center" data-id="element-119" data-mp="3cae7k3ed75r3">
          <h2 className="font-display text-xl font-bold sm:text-2xl" data-id="element-120" data-mp="3w08g2dow7wd0">
            💰 PRECIO DE LANZAMIENTO — CIERRA EN:
          </h2>
          <div className="mt-6 flex justify-center gap-3 sm:gap-6" role="timer" aria-label={`${hours} horas, ${minutes} minutos, ${seconds} segundos`} data-id="element-121" data-mp="4rb1m1ab9lvj">
            {[[hours, 'HS'], [minutes, 'MIN'], [seconds, 'SEG']].map(([value, label], index) => <Fragment key={label} data-id="element-122" data-mp="3d97fjl84jsrc" data-mpi={index}>
                <div data-id="element-123" data-mp="3daa5nqxmhr67">
                  <p className="font-display text-5xl font-bold tabular-nums text-danger sm:text-7xl" data-id="element-124" data-mp="3dasavd29jfq9">
                    {value}
                  </p>
                  <p className="text-xs tracking-spaced text-foreground-subtle" data-id="element-125" data-mp="3n6vc8gpajac5">
                    {label}
                  </p>
                </div>
                {index < 2 && <span className="pt-2 font-display text-4xl text-danger sm:text-6xl" aria-hidden="true" data-id="element-126" data-mp="3rzojpcc58wrx">
                    :
                  </span>}
              </Fragment>)}
          </div>
          <p className="mt-6 text-foreground-subtle" data-id="element-127" data-mp="2zf7ryhmjaxiu">
            Después sube. <b className="text-foreground" data-id="element-128" data-mp="2rfa63qn76hgx">No vuelve.</b>
          </p>
          <div className="mx-auto mt-5 max-w-md rounded-xl border border-danger/20 bg-canvas p-4 text-left" data-id="element-129" data-mp="2mijqt5j7vpwk">
            <div className="flex justify-between text-sm font-medium text-danger-soft" data-id="element-130" data-mp="315mn58vszsib">
              <span data-id="element-131" data-mp="2w7bday5idi03">Precio de lanzamiento</span>
              <span data-id="element-132" data-mp="2w9o666ct1crx">Quedan pocos</span>
            </div>
            <div className="mt-3 h-2.5 overflow-hidden rounded-full bg-track" data-id="element-133" data-mp="28h7dz2zcs4ew">
              <div className="h-full w-[68%] rounded-full bg-danger" data-id="element-134" data-mp="23j5vaj5ua73y" />
            </div>
            <p className="mt-2 text-right text-xs text-foreground-faint" data-id="element-135" data-mp="2ig6j4bkwthx5">
              Cupos disponibles al precio de lanzamiento
            </p>
          </div>
        </div>
      </div>
      <div className="px-4 py-16 sm:py-24" data-id="element-136" data-mp="2djg5duwkuyew">
        <div className="mx-auto max-w-2xl" data-id="element-137" data-mp="3tuae9l38hc3s">
          <h2 className="text-center font-display text-3xl font-bold sm:text-4xl" data-id="element-138" data-mp="3txg3d0bv4dzi">
            🌿 TU SISTEMA COMPLETO
          </h2>
          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mt-8 rounded-3xl border-2 border-primary bg-canvas p-6 shadow-featured sm:p-9" data-id="element-139" data-mp="9udy4r1spjr">
            <div className="flex flex-col gap-4 sm:flex-row sm:justify-between" data-id="element-140" data-mp="3rgorh22xvmhq">
              <div data-id="element-141" data-mp="3rirh3l06jdlx">
                <h3 className="font-display text-lg font-bold text-primary-soft" data-id="element-142" data-mp="j0vdatw2yn3u">
                  SISTEMA EQUILIBRIO EN CASA™
                </h3>
                <p className="mt-1 text-sm text-foreground-subtle" data-id="element-143" data-mp="nyn41kkzo36g">
                  4 Volúmenes + 5 Bonos · Acceso inmediato
                </p>
                <p className="mt-3 text-sm text-primary-soft" data-id="element-144" data-mp="ea54t7scy44x">
                  {description}
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-145" data-mp="11yoe9qn58myl">
                <p className="text-xs uppercase tracking-wider text-foreground-faint" data-id="element-146" data-mp="11xwk8k972xaf">
                  Precio original
                </p>
                <p className="text-foreground-faint line-through" data-id="element-147" data-mp="3f8jweei9an6t">$65.000</p>
                <p className="mt-2 text-xs uppercase tracking-wider text-primary-soft/70" data-id="element-148" data-mp="3a8p8mjts2dpz">
                  Precio lanzamiento
                </p>
                <p className="font-display text-4xl font-bold text-primary-soft" data-id="element-149" data-mp="359umb7wlq714">
                  $19.990
                </p>
                <p className="text-xs text-foreground-subtle" data-id="element-150" data-mp="31a3rmt3yf6rb">ARS</p>
              </div>
            </div>
          </motion.div>
          <ActionButton className="mt-7" showTrust data-id="element-151" data-mp="3syf0ay28ujdo">
            🌿 QUIERO MI SISTEMA DE AUTOCUIDADO
          </ActionButton>
        </div>
      </div>
    </section>;
}